export const WEIGHT_LOSS_CATEGORY_SLUG = 'weight-loss';
export const WEIGHT_LOSS_CAP_MESSAGE = 'Only one weight-loss peptide per membership.';

interface CategorizedProduct {
  _id: string;
  primaryCategorySlug?: string;
}

export function isWeightLossProduct(
  productId: string,
  products: CategorizedProduct[]
): boolean {
  const p = products.find(x => x._id === productId);
  return p?.primaryCategorySlug === WEIGHT_LOSS_CATEGORY_SLUG;
}

/**
 * Returns true if adding `candidateId` to `currentlyPicked` would exceed the
 * one-weight-loss-peptide limit. Returns false when the candidate is already
 * in the selection (de-select is always allowed) or when no weight-loss product
 * is already picked.
 */
export function wouldExceedWeightLossCap(
  candidateId: string,
  currentlyPicked: string[],
  products: CategorizedProduct[]
): boolean {
  if (currentlyPicked.includes(candidateId)) return false;
  if (!isWeightLossProduct(candidateId, products)) return false;
  return currentlyPicked.some(id => isWeightLossProduct(id, products));
}
